<template>
	<div class="stepContent">
		<ul class="formSteps">
			<li class="step stepOne">
				<p class="step_ttl">希望日<br class="sp">選択</p>
				<!-- <p class="step_cont">見学希望日選択</p> -->
			</li>
			<li class="step stepTwo">
				<p class="step_ttl">情報<br class="sp">入力</p>
				<!-- <p class="step_cont">お客様情報入力</p> -->
			</li>
			<li class="step stepThree">
				<p class="step_ttl">入力<br class="sp">確認</p>
				<!-- <p class="step_cont">お客様情報確認</p> -->
			</li>
			<li class="step stepFour">
				<p class="step_ttl">予約<br class="sp">完了</p>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'Step',
	data () {
		return {
			
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	// ステップ
	.formSteps {
		display: flex;
		justify-content: space-between;
		width: 684px;
		list-style: none;
		margin: 0 auto;
	}

	// 768以下
	.picxel .formSteps {
		width: 100%;
	}

	.step {
		text-align: center;
		color: #FFF;
		&_ttl {
			position: relative;
			font-size: 20px;
			font-weight: bold;
			letter-spacing: 0.05em;
			border-radius: 4px;
			// background-color: #D5D5D5;
			border: 1px solid #000;
			padding: 7px 19px 10px;
			color: #000;
			&::after {
				content: "";
				position: absolute;
				top: 50%;
				right: -40px;
				transform: translate(-50%, -50%);
				width: 0;
				height: 0;
				border-left: 10px solid #000;
				border-top: 7.5px solid transparent;
				border-bottom: 7.5px solid transparent;
			}
		}
		// &_cont {
		// 	font-size: 16px;
		// 	text-align: center;
		// 	letter-spacing: 0.075em;
		// 	font-weight: bold;
		// }
	}

	// 768以下
	.picxel .step {
		width: calc(100% / 4 - 15px);
		&_ttl {
			font-size: 14px;
			padding: 5px 0;
			border-radius: 4px;
			&::after {
				content: "";
				position: absolute;
				right: -21px;
				border-left: 10px solid #D5D5D5;
				border-top: 7.5px solid transparent;
				border-bottom: 7.5px solid transparent;
			}
		}
		&_cont {
			text-align: left;
			font-size: 13px;
		}
	}

	.stepOne {
		.step_ttl {
			background-color: #000;
			color: #fff;
			&::after {
				border-left: 10px solid #000;
				border-top: 7.5px solid transparent;
				border-bottom: 7.5px solid transparent;
			}
		}
	}

	.stepFour {
		.step_ttl {
			&::after {
				display: none;
			}
		}
	}

	// お客様情報入力の画面時
	.twoStep {
		.stepOne {
			.step_ttl {
				background-color: #000;
				color: #fff;
				&::after {
					border-left: 10px solid #000;
					border-top: 7.5px solid transparent;
					border-bottom: 7.5px solid transparent;
				}
			}
		}
		.stepTwo {
			.step_ttl {
				background-color: #000;
				color: #fff;
				&::after {
					border-left: 10px solid #000;
					border-top: 7.5px solid transparent;
					border-bottom: 7.5px solid transparent;
				}
			}
		}
	}

	// お客様情報確認の画面時
	.threeStep {
		.stepOne {
			.step_ttl {
				background-color: #000;
				color: #fff;
				&::after {
					border-left: 10px solid #000;
					border-top: 7.5px solid transparent;
					border-bottom: 7.5px solid transparent;
				}
			}
		}
		.stepTwo {
			.step_ttl {
				background-color: #000;
				color: #fff;
				&::after {
					border-left: 10px solid #000;
					border-top: 7.5px solid transparent;
					border-bottom: 7.5px solid transparent;
				}
			}
		}
		.stepThree {
			.step_ttl {
				// background-color: #af9754;
				background-color: #000;
				// border: 1px solid #000;
				color: #fff;
				&::after {
					border-left: 10px solid #000;
					border-top: 7.5px solid transparent;
					border-bottom: 7.5px solid transparent;
				}
			}
		}
	}

	// 予約完了の画面時
	.fourStep {
		.stepOne {
			.step_ttl {
				background-color: #af9754;
				&::after {
					border-left: 10px solid #af9754;
					border-top: 7.5px solid transparent;
					border-bottom: 7.5px solid transparent;
				}
			}
		}
		.stepTwo {
			.step_ttl {
				background-color: #af9754;
				&::after {
					border-left: 10px solid #af9754;
					border-top: 7.5px solid transparent;
					border-bottom: 7.5px solid transparent;
				}
			}
		}
		.stepThree {
			.step_ttl {
				background-color: #af9754;
				&::after {
					border-left: 10px solid #af9754;
					border-top: 7.5px solid transparent;
					border-bottom: 7.5px solid transparent;
				}
			}
		}
		.stepFour {
			.step_ttl {
				background-color: #af9754;
			}
		}
	}

	.sp {
		display: none;
	}

	.picxel .sp {
		display: block;
	}
</style>
